import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbDropdownModule, NgbDatepickerModule, NgbDateParserFormatter, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { Subject } from 'rxjs';
import { UtilityService } from '../../../Model/utility/utility.service';
import { AdditionOfManpowerService } from '../../../Model/AdditionReductionOfManpower/addition-of-manpower.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ComboService } from '../../../Model/Combo/combo.service';
import { CommonService } from '../../../Model/Common/common.service';

@Component({
  selector: 'app-view-of-allocate-manpower-new',
  standalone: true,
  imports: [FormsModule, CommonModule, LoaderComponent, NgbDropdownModule, NgSelectModule, NgbDatepickerModule, DataTablesModule],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
  templateUrl: './view-of-allocate-manpower-new.component.html',
  styleUrl: './view-of-allocate-manpower-new.component.scss'
})
export class ViewOfAllocateManpowerNewComponent {
  isDisabled: boolean = false;

  Branchs: any[] = [];
  Clients: any[] = [];
  Sites: any[] = [];
  Manpowers: any[] = [];

  Filter = {
    BranchID: null as any,
    ClientID: null as any,
    SiteID: null as any,
    Date: null as any,
    IsAllTransactions: false,
  }

  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private utility: UtilityService,
    private dateFormate: CustomDateParserFormatter,
    private modalService: NgbModal,
    private router: Router,
    private siteadditionreduction: AdditionOfManpowerService,
    private comboload: ComboService,
    private route: ActivatedRoute,
    protected common: CommonService,
  ) {
    this.common.getPageRights();
    this.route.params.subscribe(params => this.Filter.BranchID = isNaN(parseInt(params['bid'])) ? null : parseInt(params['bid']));
    this.route.params.subscribe(params => this.Filter.ClientID = isNaN(parseInt(params['cid'])) ? null : parseInt(params['cid']));
    this.route.params.subscribe(params => this.Filter.SiteID = isNaN(parseInt(params['sid'])) ? null : parseInt(params['sid']));
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.SelectDate('RegistrationDate', null, null);
    this.ComboLoad('Branch', false);
    this.ComboLoad('Client', false);
    this.ComboLoad('Site', false);
    //this.Count();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  Validate(form: any) {
    if (form.valid) {
      this.add();
    } else {
      form.submitted = true;
    }
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    this.isDisabled = true;
    return this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          //this.Filter.Date = this.dateFormate.parse(response.Table[0].RegistrationDate)
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ComboLoad(Combotype: String, isClear = true) {
    this.isDisabled = true
    this.Manpowers = [];
    if (isClear) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    }

    if (Combotype == 'Branch' && isClear) {
      this.Branchs = [];
      this.Clients = [];
      this.Sites = [];

      this.Filter.BranchID = null;
      this.Filter.ClientID = null;
      this.Filter.SiteID = null;
    } else if (Combotype == 'Client' && isClear) {
      this.Clients = [];
      this.Sites = [];

      this.Filter.ClientID = null;
      this.Filter.SiteID = null;
    } else if (Combotype == 'Site' && isClear) {
      this.Sites = [];

      this.Filter.SiteID = null;
    }
    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'BranchId': this.Filter.BranchID,
      'ClientId': this.Filter.ClientID,
      'SiteId': this.Filter.SiteID,
    }).subscribe({
      next: (response) => {
        if (response.ComboLoad.length >= 0) {
          if (Combotype == 'Branch') {
            this.Branchs = response.ComboLoad;
          } else if (Combotype == 'Client') {
            this.Clients = response.ComboLoad;
          } else if (Combotype == 'Site') {
            this.Sites = response.ComboLoad;
          }
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  add() {
    if (this.common.PageRight.IsView) {
      this.isDisabled = true;
      this.Manpowers = Object.values([]);
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });

      this.siteadditionreduction.ESS_SiteManpowerAdditionReductionGet({
        SelectType: 'View',
        ESS_ShiftWiseManpowerDetailsId: 0,
        AllocationType: '',
        WoNo: '',
        SiteId: this.Filter.SiteID,
        DesignationId: '',
        DutyId: '',
        ShiftId: '',
        AsOnDate: this.Filter.IsAllTransactions ? '' : this.dateFormate.format(this.Filter.Date)
      }).subscribe({
        next: (response) => {
          if (response.Table.length > 0) {
            this.Manpowers = Object.values(response.Table);
            this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
              dtInstance.destroy();
              this.dtTrigger.next(null);
            });
          }
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    }
  }

  onEditClick(element: any): void {
    if ((element.AllocationType == 'A' || element.AllocationType == 'O') && ((element.ESS_ShiftWiseManpowerMasterId == 0 && this.common.PageRight.IsAdd) || (element.ESS_ShiftWiseManpowerMasterId > 0 && this.common.PageRight.IsEdit))) {
      this.router.navigate(['master/AdditionOfManpowerNew/' + element.ESS_ShiftWiseManpowerMasterId + '/' + (element.AllocationType == 'O' ? 'o' : 'v')]);
    }
    else if (element.AllocationType == 'R' && ((element.ESS_ShiftWiseManpowerMasterId == 0 && this.common.PageRight.IsAdd) || (element.ESS_ShiftWiseManpowerMasterId > 0 && this.common.PageRight.IsEdit))) {
      //this.router.navigate(['master/ReductionOfManpower'], navigationID);
      this.router.navigate(['master/ReductionOfManpowerNew/' + element.ESS_ShiftWiseManpowerMasterId + '/v']);
    }
  }

  Back() {
    this.router.navigate(['master/sitewisemanpowersummarynew']);
  }
}
